import Bugsnag from '@bugsnag/js';

const MAX_PENDING_REPORTS = 10;
const pendingReports: Error[] = [];

const toError = (error: unknown): Error =>
	error instanceof Error ? error : new Error(String(error));

const send = (error: Error): void => {
	try {
		Bugsnag.notify(error);
	} catch (reportError) {
		// eslint-disable-next-line no-console
		console.warn('Bugsnag report failed', reportError);
	}
};

/** Reports `error`, holding up to 10 raised before the client starts; never throws. */
export const notifyBugsnag = (error: unknown): void => {
	if (Bugsnag.isStarted()) {
		send(toError(error));
		return;
	}
	if (pendingReports.length < MAX_PENDING_REPORTS) pendingReports.push(toError(error));
};

export const flushPendingBugsnagReports = (): void => {
	pendingReports.splice(0).forEach(send);
};
